import { Chakra } from "@airhelp/react-ui-components";
import { useModal } from "contexts/ModalContext";
import getUrlFromLink from "utils/getUrlFromLink";
import { trackClickEvent, buildTrackingBasedId } from "utils/trackingUtils";
import type { As, ButtonProps } from "@chakra-ui/react";
import type { ReactStoryblokComponent } from "modules/storyblok/types";
import type { ButtonStoryblokAdapterProps } from "./Button.d";
import { modals, sizes, variants } from "./Button.config";

const { Button } = Chakra;

const ButtonStoryblokAdapter = ({
  blok: { size, text, variant, link, modal, modalSize = "md", gtmSection, gtmElement },
}: ReactStoryblokComponent<ButtonStoryblokAdapterProps>) => {
  const {
    openModal,
  }: {
    // TODO | Remove after the end of the migration ModalContext to TS
    openModal?: (modalComponent: JSX.Element, sizeOfModal: ButtonStoryblokAdapterProps["modalSize"]) => void;
  } = useModal();

  const trackingEvents = () => trackClickEvent(gtmSection, gtmElement);

  const buttonModalProps = {
    size: sizes[size],
    onClick: () => {
      openModal(modals[modal], modalSize);
      trackingEvents();
    },
    variant: variants[variant],
    minW: "fit-content",
    whiteSpace: "nowrap",
  } as ButtonProps;

  const buttonProps = {
    onClick: trackingEvents,
    variant: variants[variant],
    size: sizes[size],
    as: "a" as As<unknown>,
    href: getUrlFromLink(link),
  };

  const props = modal ? buttonModalProps : buttonProps;

  return (
    <Button id={buildTrackingBasedId(gtmSection, gtmElement)} {...props}>
      {text}
    </Button>
  );
};

export default ButtonStoryblokAdapter;
